import { type IntervalLabel, INTERVAL_BY_LABEL } from '@theory/intervals';
import styles from './IntervalBadge.module.css';

interface IntervalBadgeProps {
  intervalLabel: IntervalLabel;
  noteName: string;
}

export function IntervalBadge({ intervalLabel, noteName }: IntervalBadgeProps) {
  const info = INTERVAL_BY_LABEL[intervalLabel];
  const colour = info?.colour ?? 'var(--colour-interval-other)';
  return (
    <span className={styles.badge} style={{ ['--badge-colour' as string]: colour }}>
      <span className={styles.interval}>{intervalLabel}</span>
      <span className={styles.note}>{noteName}</span>
    </span>
  );
}
